import React, { useContext } from 'react';
import { InstanceContext } from '../../contexts/instance-provider';
import { useVersionInfo } from '../../contexts/version-info';

const VersionPanel: React.FC = () => {
  const instance = useContext(InstanceContext);
  const { loadedGameDocumentVersion } = useVersionInfo();

  // Get the required data
  const appVersion = instance.version;
  const isDevEnvironment = instance.features !== 'Production';

  // Do not render on production
  if (!isDevEnvironment || !appVersion) {
    return null;
  }

  return (
    <div className={'version-panel'}>
      {instance.siteName} v{appVersion} | {instance.features} Environment
      {loadedGameDocumentVersion && (
        <>
          <br /> Loaded Game Document v{loadedGameDocumentVersion}
        </>
      )}
    </div>
  );
};

export default VersionPanel;
